"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerGenerateReport = void 0;
/**
 * Get locations for all or filtered jobs. This will intentionally return duplicates, so they can be used to form a heat-map of job locations
 */
var triggerGenerateReport = function (instance) { return function (config) {
    return instance.get("/reports/schedules/test-trigger", config);
}; };
exports.triggerGenerateReport = triggerGenerateReport;
